import { createSelector } from 'reselect'
import getTasteOfGoldPromoCampaign from 'takeovers/tasteOfGoldTakeover/selectors/getTasteOfGoldPromoCampaign'
import getCheckoutInternationalItemsTotal from './getCheckoutInternationalItemsTotal'
import { TASTE_OF_GOLD_MIN_PRICE } from 'takeovers/tasteOfGoldTakeover/constants/tasteOfGoldConstants'

/**
 * Whether the checkout cart qualifies for Taste of Gold benefits.
 * Requires the ToG campaign to be active and the combined international
 * accommodation total to meet the minimum price threshold.
 */
const getIsTasteOfGoldEligibleCheckout = createSelector(
  (state: App.State) => getTasteOfGoldPromoCampaign(state),
  (state: App.State) => getCheckoutInternationalItemsTotal(state),
  (state: App.State) => state.geo.currentCurrency,
  (tasteOfGoldCampaign, internationalItemsTotal, currency): boolean => {
    return !!tasteOfGoldCampaign &&
      tasteOfGoldCampaign.available > 0 &&
      currency === 'AUD' &&
      internationalItemsTotal >= TASTE_OF_GOLD_MIN_PRICE
  },
)

export default getIsTasteOfGoldEligibleCheckout
